export interface CannotReserveDate {
    date: string
}

export default class AdminReserveAvailabilityOvernight {
    condominiumCd: string
    facilityId: number
    targetDate: string
    otherReserves: CannotReserveDate[]
    outOfHours: CannotReserveDate[]

    constructor(
        condominiumCd: string,
        facilityId: number,
        targetDate: string,
        otherReserves: CannotReserveDate[] = [],
        outOfHours: CannotReserveDate[],
    ) {
        this.condominiumCd = condominiumCd
        this.facilityId = facilityId
        this.targetDate = targetDate
        this.otherReserves = otherReserves
        this.outOfHours = outOfHours
    }

    static from(json: any): AdminReserveAvailabilityOvernight {

        return new AdminReserveAvailabilityOvernight(
            json.condominiumCd,
            json.facilityId,
            json.targetDate,
            json.otherReserves,
            json.outOfHours,
        )
    }
}

